import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

export default WithDirection(styled.div`
    margin: 0 auto; display: inline-block; max-width: 60vw; width: 100%;
    
    .search-app-bar-border-wrapper {
        display: flex;
        align-items: center;
        border: 1px solid rgba(151, 151, 151, 1);
        border-radius: 20px;
        height: 40px;
        background-color: rgba(255, 255, 255, 1);
        padding: 0 10px;
    }

    .search-app-bar-border-wrapper > img {
        position: absolute;
        top: 50%;
        right: 9px;
        margin-right: 10px;
        height: 18px;
        transform: translateY(-50%);
    }

    @media screen and (max-width: 767px) {
        max-width: 100%;
    }
`);


// WEBPACK FOOTER //
// ./src/components/SearchAppBar/Wrapper.js